export default "__VITE_ASSET__Ce6RyP8O__"